import React from 'react';
import { connect } from 'react-redux';
import { DBCheckBox, DBCheckBoxComment, DBTextAreaObjective, DBRadioButton, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpeechVoice extends React.Component {

    render() {
        return (
            <div>
                    <div className={styles.row}>
                    {this.props.flagged && <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} flagText='Voice' />}
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSVOISTATUS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                            
                            
                             <div className={styles.label} />

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSVOISTATUS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
 
                    </div>

                    <div className={styles.row}>
                        <b>Comments</b>
                    </div>

                <div className={styles.row}>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSVOICOMMENTS'
                        className={styles.textarea}
                    />
                </div>

                <div className={styles.row}>
                        <b>Quality</b>
                </div>

                <div className={styles.formRowSetting}>
                <div className={styles.flgCol}>
                    {this.props.qualityFlagged && <ObjectiveFlag flagged={this.props.qualityFlagged} flagText='Quality' />}
                </div>
             <div className={styles.flgCheckbox}>
                <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSVOIQUALITYWNL'
                        label='WNL'
                    />
                    <div className={styles.label} />
                <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSVOIQUALITYSTRAIN'
                        label='Stained / Harsh'
                    />
                    <div className={styles.label} />
                <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSVOIQUALITYBREATHY'
                        label='Breathy'
                    />
                 </div>
                </div>
              
                <div className={styles.formRowSetting}>
                <div className={styles.flgCol} />
                <div className={styles.flgCheckbox}>
                <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSVOIQUALITYHOARSE'
                        label='Hoarse'
                    />
                 <div className={styles.CheckboxSpace}/> 
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSVOIQUALITYROUGH'
                        label='Rough'
                    />    
                    <div className={styles.formCheckboxSpace}/> 
                     <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSVOIQUALITYAPHONIC'
                        label='Aphonic'
                    />
                    </div>
                </div>
                <br/>
                <div className={styles.formRowSetting}>
                <div className={styles.formContainer}>
                <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSVOIPITCH'
                         className={styles.checkbox}
                         label='Pitch'
                         textAreaStyle={styles.formTextArea}
                         displayFlag= {this.props.pitchFlagged}
                    />
                    </div>
                    <div>
                         <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Normal'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSVOIPITCHSTATUS'
                             entityKeyValue={this.props.osno}
                             label='Normal'
                             className={styles.formRadio}
                            />       
                                 <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'High'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSVOIPITCHSTATUS'
                             entityKeyValue={this.props.osno}
                             label='High'
                             className={styles.formRadio}
                            />          
                                 <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Low'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSVOIPITCHSTATUS'
                             entityKeyValue={this.props.osno}
                             label='Low'
                             className={styles.formRadio}
                            />   
                    </div>
                </div>

                <div className={styles.formRowSetting}>
                <div className={styles.formContainer}>
                    
                <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSVOIINTENSITY'
                         className={styles.checkbox}
                         label='Intensity'
                         textAreaStyle={styles.formTextArea}
                         displayFlag= {this.props.intensityFlagged}
                    />
                    </div>
                    <div>
                         <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Normal'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSVOIINTENSITYSTATUS'
                             entityKeyValue={this.props.osno}
                             label='Normal'
                             className={styles.formRadio}
                            />   
                                 <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Loud'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSVOIINTENSITYSTATUS'
                             entityKeyValue={this.props.osno}
                             label='Loud'
                             className={styles.formRadio}
                            />   
                                 <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Soft'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSVOIINTENSITYSTATUS'
                             entityKeyValue={this.props.osno}
                             label='Soft'
                             className={styles.formRadio}
                            />   
                    </div>
                </div>

                <div className={styles.formRowSetting}>
                <div className={styles.formContainer}>
                    
                <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSVOIRESONANCE'
                         className={styles.checkbox}
                         label='Resonance'
                         textAreaStyle={styles.formTextArea}
                         displayFlag= {this.props.resonanceFlagged}
                    />
                    </div>
                    <div>
                         <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Normal'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSVOIRESONANCESTATUS'
                             entityKeyValue={this.props.osno}
                             label='Normal'
                             className={styles.formRadio}
                            />   
                                 <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Hypernasal'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSVOIRESONANCESTATUS'
                             entityKeyValue={this.props.osno}
                             label='Hypernasal'
                             className={styles.formRadio}
                            />   
                                 <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Hyponasal'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSVOIRESONANCESTATUS'
                             entityKeyValue={this.props.osno}
                             label='Hyponasal'
                             className={styles.formRadio}
                            />   
                    </div>
                </div>
            </div>

            
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let osno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPEECH)
    .find(key => (state.entities.notes.PTOBJECTIVESPEECH[key].OSEVNO === pk && noteType === 1)
        || (state.entities.notes.PTOBJECTIVESPEECH[key].OSNTNO === pk && noteType !== 1)));
        
    return {
        noteId: noteId,
        osno: osno,
        flagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOISTATUS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOISTATUS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOISTATUS !== 'WNL'),
        qualityFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYSTRAIN !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYSTRAIN !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYSTRAIN
            || 
            state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYBREATHY !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYBREATHY !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYBREATHY
            ||
            state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYHOARSE !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYHOARSE !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYHOARSE
            ||
            state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYROUGH !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYROUGH !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYROUGH
            ||
            state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYAPHONIC !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYAPHONIC !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIQUALITYAPHONIC
        ),
        pitchFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIPITCHSTATUS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIPITCHSTATUS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIPITCHSTATUS !== 'Normal'),
        intensityFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIINTENSITYSTATUS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIINTENSITYSTATUS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIINTENSITYSTATUS !== 'Normal'),
        resonanceFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIRESONANCESTATUS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIRESONANCESTATUS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSVOIRESONANCESTATUS !== 'Normal'),
    };
}

const connectedSpeechVoice = connect(mapStateToProps)(SpeechVoice);
export { connectedSpeechVoice as SpeechVoice };


